"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ChartLegend = _interopRequireDefault(require("./ChartLegend"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ChartPieLegend extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getColorByIndex", index => {
      const colors = this.props.colors;

      if (!colors[index]) {
        index = index - colors.length;
      }

      const color = colors && colors[index];
      return color;
    });

    _defineProperty(this, "renderLegend", (data, index) => {
      const colors = this.props.colors;
      let label = data.label,
          value = data.value,
          metricType = data.metricType;

      if (metricType) {
        value = _react.default.createElement(_.FormatMetric, {
          type: metricType,
          value: value
        });
      }

      const color = this.getColorByIndex(index);
      const style = {
        backgroundColor: color
      };
      return _react.default.createElement("li", {
        key: index
      }, _react.default.createElement("div", {
        className: "admin-legend__chip",
        style: style
      }), _react.default.createElement("b", {
        className: "admin-legend__label"
      }, label), _react.default.createElement("i", {
        className: "admin-legend__value"
      }, value));
    });
  }

  render() {
    const data = this.props.data;
    return _react.default.createElement(_ChartLegend.default, null, _react.default.createElement("ul", null, data.map(this.renderLegend)));
  }

}

_defineProperty(ChartPieLegend, "defaultProps", {
  data: [],
  colors: []
});

var _default = ChartPieLegend;
exports.default = _default;
module.exports = exports.default;